import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import * as FieldTypes from 'common/utilities/constants/fieldTypes';

const styles = {
  drawerText: {
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },
  select: {
    width: 200,
  },
  input: {
    width: 200,
  },
  icon: {
    width: 20,
    height: 20,
  },
  tooltip: {
    fontSize: '0.9rem !important',
  },
};

const numberFormatZeroOptions = [
  { value: 'dash', label: 'Display as dash' },
  { value: 'number', label: 'Display as number' },
];

const dateOptions = [
  {
    value: 'mm/dd/yyyy',
    label: 'MM/DD/YYYY',
  },
  {
    value: 'mm/dd/yy',
    label: 'MM/DD/YY',
  },
];

const FieldFormat = props => {
  const {
    classes,
    fieldValues,
    updateField,
    toPositiveInteger,
    formatOptions = dateOptions,
  } = props;
  const {
    fieldType,
    textType,
    precision,
    systemField = {},
    max,
    format,
    zeroFormat = '',
  } = fieldValues || {};
  const dateFormatMenuItems = formatOptions.map(option => (
    <MenuItem
      value={option.value}
      key={option.value}
      data-test-id={`FieldDrawer-dateMenuItem-${option.value}`}
    >
      {option.label}
    </MenuItem>
  ));
  const numberFormatZeroMenuItems = numberFormatZeroOptions.map(option => (
    <MenuItem
      value={option.value}
      key={option.value}
      data-test-id={`FieldDrawer-zeroMenuItem-${option.value}`}
    >
      {option.label}
    </MenuItem>
  ));

  const isSystemField = systemField.label && systemField.label !== 'None';

  // Valid values for precision field are empty or any positive integer
  const updatePrecision = ({ target: { value } }) => {
    updateField(toPositiveInteger(value), 'precision');
  };
  // Valid values for length field are empty or any integer > 0
  const updateLength = ({ target: { value } }) => {
    updateField(toPositiveInteger(value) || null, 'max');
  };
  const showFieldLength =
    fieldType === FieldTypes.TXT && (!textType || textType === 'number');
  const numberFormatWhenZeroIsDisabled = !(
    isSystemField && textType === 'number'
  );
  return (
    <React.Fragment>
      <div>
        <Typography className={classes.drawerText} variant="subtitle1">
          Date Format:
        </Typography>
        <Select
          value={format || dateOptions[0].value}
          onChange={e => updateField(e.target.value, 'format')}
          className={classes.select}
          data-test-id="FieldDrawer-dateFormatSelect"
          disabled={textType !== 'date' && textType !== 'date_signed'}
          inputProps={{
            'data-test-id': 'FieldDrawer-dateFormatSelectInput',
          }}
        >
          {dateFormatMenuItems}
        </Select>
      </div>
      <div>
        <Typography className={classes.drawerText} variant="subtitle1">
          Number Format (Decmical Places):
        </Typography>
        <TextField
          value={precision == null ? '' : precision}
          onChange={updatePrecision}
          data-test-id="FieldDrawer-precisionTextField"
          disabled={!(isSystemField && textType === 'number')}
          inputProps={{
            'data-test-id': 'FieldDrawer-precisionTextFieldInput',
          }}
          className={classes.input}
        />
      </div>
      <div>
        <Typography className={classes.drawerText} variant="subtitle1">
          Number Format for Pre-populated Zero Values{' '}
          <Tooltip
            classes={{ tooltip: classes.tooltip }}
            title="Choose a format for pre-populated number fields that will be printed to the form when the value is zero (regardless of decimal precisions for the field)."
          >
            <InfoIcon
              data-test-id="FieldFormat-zeroNumberFormatIcon"
              className={classes.icon}
            />
          </Tooltip>
          :
        </Typography>
        <Select
          value={
            zeroFormat == null || numberFormatWhenZeroIsDisabled
              ? ''
              : zeroFormat
          }
          onChange={e => updateField(e.target.value, 'zeroFormat')}
          className={classes.select}
          data-test-id="FieldDrawer-zeroFormatSelect"
          disabled={numberFormatWhenZeroIsDisabled}
          inputProps={{
            'data-test-id': 'FieldDrawer-zeroFormatSelectInput',
          }}
        >
          {numberFormatZeroMenuItems}
        </Select>
      </div>
      <div>
        <Typography className={classes.drawerText} variant="subtitle1">
          Maximum Number Length:
        </Typography>
        <TextField
          value={max || ''}
          onChange={updateLength}
          data-test-id="FieldDrawer-fieldLengthTextField"
          inputProps={{
            'data-test-id': 'FieldDrawer-fieldLengthTextFieldInput',
          }}
          disabled={!showFieldLength}
          className={classes.input}
        />
      </div>
    </React.Fragment>
  );
};

export default withStyles(styles)(FieldFormat);
